<template>
    <div class="integral-list" v-title="'积分明细'">
        <van-nav-bar fixed left-arrow :border="false" @click-left="$router.go(-1)">
            <template #title>
                <div>积分明细</div>
            </template>
        </van-nav-bar>
        <div class="day" @click="showDate = true">
            <p>{{Year}}年{{Month}}月</p><van-icon name="arrow-down" />
        </div>
        <van-pull-refresh 
            v-model="refreshing" 
            @refresh="onRefresh"
            success-text="刷新成功"
        >
            <van-list 
                v-model="loading" 
                :finished="finished" 
                finished-text="暂无数据~" 
                @load="onLoad"
            >
                <van-cell v-for="item in record" :key="item">
                    <div class="items">
                        <div class="items-flex">
                            <label for="">{{item.OperationName}}</label>
                            <i>{{item.Score}}</i>
                        </div>
                        <p>{{item.CreateTime}}</p>
                    </div>
                </van-cell>
            </van-list>
        </van-pull-refresh>
        <van-popup v-model="showDate" position="bottom" :close-on-click-overlay="false">
            <van-datetime-picker
                v-model="currentDate"
                type="year-month"
                title="选择年月"
                :min-date="minDate"
                :max-date="maxDate"
                :formatter="formatter"
                @confirm="confirmDate"
                @cancel="showDate=false"
            />
        </van-popup>
    </div>
</template>
<script>
    import {
        GetScoreLogList,    // 获取用户积分明细
    } from '@/common/api.js'
    import bridge from '@/common/dsbridge.js';
    export default {
        data() {
            return {
                minDate: new Date(2000, 0, 1),
                maxDate: new Date(),
                loading: false,
                finished: false,
                refreshing: false,

                PageIndex: 1,
                PageSize: 10,
                Year: '',
                Month: '',
                record:[],

                showDate: false,
                currentDate: new Date(),
            }
        },
        created() {
            bridge.register('getTitleInitData', function () {
                return '{"isShowTitleBar":false}'
            });
        },
        mounted(){
            this.Year=new Date().getFullYear();
            this.Month=new Date().getMonth() + 1;
        },
        methods:{
            formatter(type, val) {
                if (type === 'year') {
                    return `${val}年`;
                }
                if (type === 'month') {
                    return `${val}月`;
                }
                return val;
            },
            confirmDate(val){
                this.Year=new Date(val).getFullYear();
                this.Month=new Date(val).getMonth() + 1;
                this.showDate = false
                this.onRefresh();
            },

            recordList(){
                if (this.refreshing) {
                    this.record = [];
                    this.refreshing = false;
                }
                let data = {}
                data.UserId = this.$route.query.userId
                data.PageIndex = this.PageIndex
                data.PageSize = this.PageSize
                data.Year = this.Year
                data.Month = this.Month
                GetScoreLogList(data).then(res=>{
                    this.loading = false;
                    let list=res.Data.List || [];
                    if(res.Result==1){
                        if(this.PageIndex==1){
                            this.record=list;
                        }else{
                            this.record=this.record.concat(list);
                        }
                        if(list.length<this.PageSize){
                            this.finished=true;
                        }else{
                            this.PageIndex++;
                        }
                    }
                })
            },

            onLoad() {
                this.recordList();
            },
            onRefresh(){
                this.finished = false;
                this.loading = true;
                this.PageIndex=1;
                this.recordList();
                document.documentElement.scrollTop=0
            },
        },
    }
</script>
<style lang="scss">
    @import '~@/style/_base.scss';
    .integral-list {
        padding-top: px2rem(148px);
        padding-bottom: px2rem(60px);
        min-height: 100vh;

        .van-nav-bar--fixed {
            top: 0;
            height: px2rem(158px);
            padding-top: px2rem(70px);

            .van-nav-bar__content {
                height: px2rem(88px);
            }

            i,
            div {
                color: #333333;
            }

            i:before {
                color: #333333;
            }
        }
    }
    .day {
        height: px2rem(100px);
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 0 px2rem(30px);
        color: #333333;
        font-size: px2rem(32px);
        p {
            margin-right: px2rem(10px);
        }
    }
    .items {
        padding-top: px2rem(12px);
        padding-bottom: px2rem(30px);
        .items-flex{
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: px2rem(60px);
            label {
                line-height: px2rem(60px);
                color: #333333;
                font-weight: bold;
                font-size: px2rem(32px);
            }
            i {
                color: #f75959;
                font-size: px2rem(32px);
            }
        }
        p {
            font-size: px2rem(28px);
            color: #666666;
            height: px2rem(32px);
        }
    }
</style>